import { ReactNode } from "react";
import { motion, AnimatePresence } from "@/lib/motion-shim";

interface StickyCTAProps {
  show: boolean;
  children: ReactNode;
  className?: string;
}

export const StickyCTA = ({ show, children, className = "" }: StickyCTAProps) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className={`fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t shadow-lg ${className}`}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
